<template>
  <svg
    :class="isOpen ? 'rotate-180' : 'rotate-0'"
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
  >
    <path
      d="M1 1.5L9 10.5L17 1.5"
      stroke="#3A405A"
      :class="[isOpen && !isHover ? 'styleCss' : '']"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>
.styleCss {
  stroke: #bdc1d4;
}
</style>

<script setup>
defineProps({ isOpen: { type: Boolean, default: true } });

const isHover = ref(false)
</script>
